import { render } from "./TyreClaimReview.vue?vue&type=template&id=14919cb6&scoped=true"
import script from "./TyreClaimReview.vue?vue&type=script&lang=js"
export * from "./TyreClaimReview.vue?vue&type=script&lang=js"

import "./TyreClaimReview.vue?vue&type=style&index=0&id=14919cb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14919cb6"]])

export default __exports__